<template>
  <v-select
    v-model="thisValue"
    :items="deviceTypeItems"
    hint="Device Type"
    item-text="description"
    item-value="model"
    label="Select Device Type"
    persistent-hint
    single-line
  ></v-select>
</template>

<script>
export default {
  name: 'OrderDetailDeviceType',
  data () {
    return {
      deviceTypeItems: [
        {model: 'aibms_uk_mp200_pp', description: 'PP AIBMS UK Castles MP200 Wi-Fi'},
        {
          model: 'aibms_uk_v3_mid_countertop_ethernet_wifi_pp',
          description: 'PP AIBMS UK Vega3000 Countertop Ethernet Wi-Fi'
        },
        {
          model: 'aibms_uk_v3_mid_countertop_ethernet_wifi_amt',
          description: 'PP AMT AIBMS UK Vega3000 Countertop Ethernet 3G'
        },
        {
          model: 'aibms_roi_v3_mid_countertop_ethernet_wifi_amt',
          description: 'PP AMT AIBMS ROI Vega3000 Countertop Ethernet 3G'
        },
        {model: 'aibms_uk_v3_mid_pinpad_ethernet_pp', description: 'PP AIBMS UK Vega3000 PIN Pad Ethernet'},
        {model: 'aibms_uk_v3_portable_wifi_pp', description: 'PP AIBMS UK Castles Vega3000 Portable Wi-Fi'},
        {model: 'aibms_roi_mp200_pp', description: 'PP AIBMS ROI Castles MP200 Wi-Fi'},
        {
          model: 'aibms_roi_v3_mid_countertop_ethernet_wifi_pp',
          description: 'PP AIBMS ROI Vega3000 Countertop Ethernet Wi-Fi'
        },
        {model: 'aibms_roi_v3_mid_pinpad_ethernet_pp', description: 'PP AIBMS ROI Vega3000 PIN Pad Ethernet'},
        {model: 'aibms_roi_v3_portable_wifi_pp', description: 'PP AIBMS ROI Castles Vega3000 Portable Wi-Fi'},
        {
          model: 'barclays_uk_v3_mid_countertop_ethernet_wifi_pp',
          description: 'PP Barclaycard UK Vega3000 Countertop Ethernet Wi-Fi'
        },
        {model: 'barclays_uk_v3_mid_pinpad_ethernet_pp', description: 'PP Barclaycard UK Vega3000 PIN Pad Ethernet'},
        {model: 'barclays_uk_v3_portable_wifi_pp', description: 'PP Barclaycard UK Castles Vega3000 Portable Wi-Fi'},
        {model: 'demo_uk_mp200_wifi', description: 'Demo UK Castles MP200 Wi-Fi'},
        {model: 'demo_uk_v3_mid_countertop_ethernet_wifi', description: 'Demo UK Vega3000 Countertop Ethernet Wi-Fi'},
        {model: 'demo_uk_v3_mid_pinpad_ethernet', description: 'Demo UK Vega3000 PIN Pad Ethernet'},
        {model: 'demo_uk_v3_portable_wifi', description: 'Demo UK Castles Vega3000 Portable Wi-Fi'},
        {model: 'demo_roi_mp200', description: 'Demo ROI Castles MP200 Wi-Fi'},
        {
          model: 'demo_roi_v3_mid_countertop_ethernet_wifi',
          description: 'Demo ROI Vega3000 Countertop Ethernet Wi-Fi'
        },
        {model: 'demo_roi_v3_mid_pinpad_ethernet', description: 'Demo ROI Vega3000 PIN Pad Ethernet'},
        {model: 'demo_roi_v3_portable_wifi', description: 'Demo ROI Castles Vega3000 Portable Wi-Fi'},
        {model: 'aibms_uk_mp200_gb', description: 'GoodBox AIBMS UK Castles MP200 Wi-Fi / 3G'}
      ]
    }
  },
  computed: {
    thisValue: {
      get () {
        return this.$store.state.order.deviceType
      },
      set (val) {
        if (val !== undefined) {
          this.$store.commit('updateOrder', ['visaEnabled', true])
          this.$store.commit('updateOrder', ['visaElectronEnabled', true])
          this.$store.commit('updateOrder', ['maestroEnabled', true])
          this.$store.commit('updateOrder', ['dinersEnabled', true])
          this.$store.commit('updateOrder', ['jcbEnabled', true])
          this.$store.commit('updateOrder', ['dinersEnabled', true])

          if (val.indexOf('barclays_') !== -1) {
            this.$store.commit('updateOrder', ['dinersEnabled', false])
          }
          if (val.indexOf('aibms_') !== -1) {
            this.$store.commit('updateOrder', ['jcbEnabled', false])
          }
          if (val.indexOf('demo_') !== -1) {
            this.$store.commit('updateOrder', ['jcbEnabled', false])
            this.$store.commit('updateOrder', ['merchantId', '010003382'])
            this.$store.commit('updateOrder', ['terminalId', '33420008'])
            this.$store.commit('updateOrder', ['macKey', '0123456789ABCDEF'])
            this.$store.commit('updateOrder', ['showDeviceName', true])
            this.$store.commit('updateOrder', ['deviceName', 'Test Device'])
          }
        }

        this.$store.commit('updateOrder', ['deviceType', val])
      }
    }
  }
}
</script>

<style scoped>

</style>
